{
  "ChangeUserAgent_Title": "Définir le profil d'affichage du navigateur",
  "ChangeUserAgent_SubTitle": "Sélectionnez le profil d’affichage du navigateur dans lequel vous souhaitez afficher le contenu de la page Web dans votre session Web actuelle sur cet ordinateur.",
  "ChangeUserAgent_FieldName_BrowserProfile": "Profil du navigateur",
  "ChangeUserAgent_Options_ForceAutomaticBrowserDetection": "[Forcer la détection automatique du navigateur]",
  "ChangeUserAgent_FooterActions_Apply": "Appliquer",
  "ChangeUserAgent_FooterActions_Cancel": "Annuler",
  "NAME": "ChangeUserAgentLanguage"
}